module.exports = __webpack_public_path__ + "img/121ef28.png";